<script>
    import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
    export default {
        name: 'Modal',
        components: {
            ButtonNormal,
        },
        props: {
            cancelButtonText: {
                type: String,
                default: 'Abbrechen',
            },
            confirmationButtonText: {
                type: String,
                default: 'Löschen',
            },
            isRed: {
                type: Boolean,
                default: false,
    
            },
            isCross: {
                type: Boolean,
                default: false,
            },
            isFooter: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            close() {
                this.$emit('close');
            },
            confirm() {
                this.$emit('confirm');
            },
        },
    
    };
</script>

<template>
    <transition name="modal-fade">
        <div>
            <div class="modal-backdrop" @click.stop="close"></div>
            <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <slot name="header">
                    </slot>
                    <img v-if="isCross" src="@/assets/starface_icons_png/32/orange/delete_32.png" alt="Close" class="cross" @click="close">
                </header>
                <section class="modal-body" id="modalDescription">
                    <slot name="body">
                    </slot>
                </section>
                <footer class="modal-footer" v-if="isFooter">
                    <slot name="footer">
                        <ButtonNormal @onClick="close" :buttonTitle="cancelButtonText" class="button" cssClass="btn btn-secondary" aria-label="Close modal" />
                        <ButtonNormal @onClick="confirm" :buttonTitle="confirmationButtonText" class="button" cssClass="btn btn-primary" :class="{'red': isRed}" aria-label="Close modal" />
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables';
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
    
    .modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #FFFFFF;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        z-index: 1001;
        max-height: 100%;
        max-width: 100%;
    }
    
    .modal-header,
    .modal-footer {
        padding: 20px;
        display: flex;
    }
    
    .modal-header {
        justify-content: space-between;
        font-weight: bold;
        position: relative;
        display: block;
        padding-right: 40px;
        .cross {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 1000;
            cursor: pointer;
        }
    }
    
    .modal-body {
        padding: 0 20px;
    }
    
    .modal-footer {
        justify-content: center;
        flex-wrap: wrap;
        padding: 10px;
    }
    
    .button {
        width: auto;
        white-space: nowrap;
        /*padding: 15px 60px;*/
        margin: 16px;
    }
    
    .red {
        background-color: $red;
    }
</style>